import React from 'react';
import PropTypes from 'prop-types';

import { setWindowLocation } from '@eb/http';
import { translationPropType } from '@eb/i18n-ebspa';

import BucketHeader from '../BucketHeader';
import { ArticleCardGroup, FeaturedArticleCardGroup } from './ArticleCardGroup';
import BigCardGroup from './BigEventCardGroup';
import SmallCardGroup from './SmallEventCardGroup';
import ListCardGroup from './ListEventCardGroup';

import {
    FEATURED_TEMPLATE,
    LARGE_CARD_TEMPLATE_3,
    LARGE_CARD_TEMPLATE_6,
    LIST_CARD_TEMPLATE,
    CARD_TEMPLATE_4,
    CARD_TEMPLATE_8,
    CARD_BIG,
    ARTICLE_TEMPLATE,
    SHARE_OPTIONS_PROPTYPE,
    GA_CITY_BROWSE_CATEGORY,
} from '../../constants';
import LoadingCards from '../../../components/ConsumerEventCard/LoadingCards';

const CARD_GROUP_MAP = {
    [ARTICLE_TEMPLATE]: ArticleCardGroup,
    [FEATURED_TEMPLATE]: FeaturedArticleCardGroup,
    [LARGE_CARD_TEMPLATE_3]: BigCardGroup,
    [LARGE_CARD_TEMPLATE_6]: BigCardGroup,
    [LIST_CARD_TEMPLATE]: ListCardGroup,
    [CARD_TEMPLATE_4]: SmallCardGroup,
    [CARD_TEMPLATE_8]: SmallCardGroup,
    [CARD_BIG]: BigCardGroup,
};

export default class CardBucket extends React.PureComponent {
    static propTypes = {
        /*
         * Array of preformatted objects that will represent that cards within the bucket
         */
        content: PropTypes.arrayOf(PropTypes.object).isRequired,
        /*
         * The manner in which this CardBucket should display its content
         */
        template: PropTypes.string.isRequired,
        /*
         * Share options
         */
        shareOptions: SHARE_OPTIONS_PROPTYPE.isRequired,
        /*
         * The name of the given bucket ie. "Upcoming Music Events"
         */
        name: translationPropType,
        /*
         * The url clicking "See More" should connect the user to
         */
        linkUrl: PropTypes.string,
        /*
         * Callback for handling click on save event
         */
        onSaveEvent: PropTypes.func,
        /*
         * Is user authenticated?
         */
        isAuthenticated: PropTypes.bool,
        /*
         * The key of the associated bucket
         */
        bucketKey: PropTypes.string,
        /*
         * Tracking callback for event clicks
         */
        onTrackEventClickInternal: PropTypes.func,
        /*
         * Track GA Events from state
         */
        trackGAEvent: PropTypes.func,
        /*
         * Track GA Events from state
         */
        trackGAEventOnPageUnload: PropTypes.func,
        isLoading: PropTypes.bool,
    };

    _handleTrackClick = ({ url, id }, action) => {
        const { bucketKey, trackGAEventOnPageUnload } = this.props;

        if (bucketKey) {
            trackGAEventOnPageUnload({
                category: GA_CITY_BROWSE_CATEGORY,
                action,
                label: bucketKey,
                dimensions: {
                    eventId: id,
                },
            });
        }

        /* Need to fire tracking action on the seemore, so necessary to
        manually set windowlocation rather that relying on the link. */
        if (url) {
            setWindowLocation(url);
        }
    };

    _handleTrackClickInternal = (index, id, ticketsBy) => {
        const { bucketKey, onTrackEventClickInternal } = this.props;

        const trackingData = {
            clickRank: index,
            navigation: `city_browse.${bucketKey}`,
            itemId: id,
        };

        onTrackEventClickInternal(trackingData, ticketsBy);
    };

    render() {
        const {
            content,
            name,
            template,
            linkUrl,
            onSaveEvent,
            shareOptions,
            isAuthenticated,
            experiments,
            featureFlags,
            trackGAEvent,
            trackGAEventOnPageUnload,
            bucketKey,
            userCollections,
            onAddOrRemoveEventToCollection,
            onCreateCollection,
            isLoading,
        } = this.props;

        const DynamicCardGroup = CARD_GROUP_MAP[template];
        const isSmallCity = template === CARD_BIG;

        //TODO: dyanmically determine the loading card type based off template

        return (
            <div>
                <BucketHeader
                    title={name}
                    linkUrl={linkUrl}
                    template={template}
                    trackGAEvent={trackGAEvent}
                    bucketKey={bucketKey}
                />
                {isLoading ? (
                    <section className="eds-l-pad-left-6">
                        <LoadingCards cardCount={3} />
                    </section>
                ) : (
                    <DynamicCardGroup
                        cards={content}
                        linkUrl={linkUrl}
                        onSaveEvent={onSaveEvent}
                        shareOptions={shareOptions}
                        isAuthenticated={isAuthenticated}
                        onTrackClick={this._handleTrackClick}
                        onTrackClickInternal={this._handleTrackClickInternal}
                        trackGAEvent={trackGAEvent}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                        isSmallCity={isSmallCity}
                        title={name}
                        experiments={experiments}
                        featureFlags={featureFlags}
                        userCollections={userCollections}
                        onAddOrRemoveEventToCollection={
                            onAddOrRemoveEventToCollection
                        }
                        onCreateCollection={onCreateCollection}
                    />
                )}
            </div>
        );
    }
}
